// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, collection, getDocs, deleteDoc, addDoc, updateDoc, doc } from "firebase/firestore";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_FIREBASE_APPID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);
export const auth = getAuth();

export const getStreamsFromFirestore = async () => {
  const streamsCollection = collection(firestore, 'streams');
  const streamsSnapshot = await getDocs(streamsCollection);
  const streams = streamsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
  return streams;
}

export const getAnnouncementBarFromFirestore = async () => {
  const content = collection(firestore, 'website-content');
  const contentSnapshot = await getDocs(content);
  const announcementBar = contentSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })).filter((docu) => docu.id === "announcement-bar");
  return announcementBar;
}

export const setAnnouncementBarToFirestore = async (msg, show) => {
  const bar = doc(firestore, 'website-content', 'announcement-bar');
  await updateDoc(bar, {
    message: msg,
    visible: show
  })
  


}

export const setVideosToFirestore = async (videos) => {

  const videosCollection = collection(firestore, 'videos');
  const videosSnapshot = await getDocs(videosCollection);

  const videosObject = {videos: videos}

  for (const doc of videosSnapshot.docs) {
    await deleteDoc(doc.ref);
  }
  const setVideos = await addDoc(collection(firestore, 'videos'), videosObject);
  return setVideos;
}

export const getVideosFromFirestore = async () => {
    const videosCollection = collection(firestore, 'videos')
    const videosSnapshot = await getDocs(videosCollection)
    const videos = videosSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    return videos;

}


export const clearSavedStreams = async () => {
  const streamsCollection = collection(firestore, 'streams')
  const streamsSnapshot = await getDocs(streamsCollection)

  for (const doc of streamsSnapshot.docs) {
    await deleteDoc(doc.ref);
  }
}

export const setStreamsToFirestore = async (streams) => {
  const streamsCollection = collection(firestore, 'streams');
  const streamsSnapshot = await getDocs(streamsCollection);

  for (const doc of streamsSnapshot.docs) {
    await deleteDoc(doc.ref);
  }
  
  const streamsObject = {streams: streams}
  const setStreams = await addDoc(collection(firestore, 'streams'), streamsObject);
  return setStreams;
}

export const login = async (email, password) => {

  return signInWithEmailAndPassword(auth, email, password);
}


export const logout = async () => {
  return auth.signOut();
};
  

